Object.defineProperty(exports,"__esModule",{value:true});var _range2=require("lodash/range");var _range3=_interopRequireDefault(_range2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=

{
circle:function circle(x,y,size){
var s=Math.round(size);
return"M "+Math.round(x)+", "+Math.round(y)+" m "+-s+", 0\n      a "+
s+", "+s+" 0 1,0 "+s*2+",0\n      a "+
s+", "+s+" 0 1,0 "+-s*2+",0";
},

square:function square(x,y,size){
var baseSize=0.87*size;
var x0=Math.round(x-baseSize);
var x1=Math.round(x+baseSize);
var y0=Math.round(y-baseSize);
var y1=Math.round(y+baseSize);
return"M "+x0+", "+y1+"\n      L "+
x1+", "+y1+"\n      L "+
x1+", "+y0+"\n      L "+
x0+", "+y0+"\n      z";

},

diamond:function diamond(x,y,size){
var baseSize=0.87*size;
var length=Math.sqrt(2*(baseSize*baseSize));
return"M "+Math.round(x)+", "+Math.round(y+length)+"\n      L "+
Math.round(x+length)+", "+Math.round(y)+"\n      L "+
Math.round(x)+", "+Math.round(y-length)+"\n      L "+
Math.round(x-length)+", "+Math.round(y)+"\n      z";

},

triangleDown:function triangleDown(x,y,size){
var height=size/2*Math.sqrt(3);
var x0=Math.round(x-size);
var x1=Math.round(x+size);
var y0=Math.round(y-size);
var y1=Math.round(y+height);
return"M "+x0+", "+y0+"\n      L "+
x1+", "+y0+"\n      L "+
Math.round(x)+", "+y1+"\n      z";

},

triangleUp:function triangleUp(x,y,size){
var height=size/2*Math.sqrt(3);
var x0=Math.round(x-size);
var x1=Math.round(x+size);
var y0=Math.round(y-height);
var y1=Math.round(y+size);
return"M "+x0+", "+y1+"\n      L "+
x1+", "+y1+"\n      L "+
Math.round(x)+", "+y0+"\n      z";

},

plus:function plus(x,y,size){
var baseSize=1.1*size;
return"M "+Math.round(x-baseSize/2.5)+", "+Math.round(y+baseSize)+"\n      L "+
Math.round(x+baseSize/2.5)+", "+Math.round(y+baseSize)+"\n      L "+
Math.round(x+baseSize/2.5)+", "+Math.round(y+baseSize/2.5)+"\n      L "+
Math.round(x+baseSize)+", "+Math.round(y+baseSize/2.5)+"\n      L "+
Math.round(x+baseSize)+", "+Math.round(y-baseSize/2.5)+"\n      L "+
Math.round(x+baseSize/2.5)+", "+Math.round(y-baseSize/2.5)+"\n      L "+
Math.round(x+baseSize/2.5)+", "+Math.round(y-baseSize)+"\n      L "+
Math.round(x-baseSize/2.5)+", "+Math.round(y-baseSize)+"\n      L "+
Math.round(x-baseSize/2.5)+", "+Math.round(y-baseSize/2.5)+"\n      L "+
Math.round(x-baseSize)+", "+Math.round(y-baseSize/2.5)+"\n      L "+
Math.round(x-baseSize)+", "+Math.round(y+baseSize/2.5)+"\n      L "+
Math.round(x-baseSize/2.5)+", "+Math.round(y+baseSize/2.5)+"\n      z";

},

star:function star(x,y,size){
var baseSize=1.35*size;
var angle=Math.PI/5;
var starCoords=(0,_range3.default)(10).map(function(index){
var length=index%2===0?baseSize:baseSize/2;
return length*Math.sin(angle*(index+1))+x+",\n        "+(
length*Math.cos(angle*(index+1))+y);
});
return"M "+starCoords.join("L")+" z";
}};


//////////////////
// WEBPACK FOOTER
// ./~/victory-core/lib/victory-primitives/path-helpers.js
// module id = 1381
// module chunks = 0